import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CustomTitleStrategy extends TitleStrategy {
  private readonly baseTitle = 'MAFA';
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`${title} - ${this.baseTitle}`);
    } else {
      this.title.setTitle(this.baseTitle);
    }
  }

  override buildTitle(routerState: RouterStateSnapshot): string | undefined {
    let route = routerState.root;
    let title: string | undefined;

    // Traverse the route tree to find the deepest route with a title
    while (route) {
      if (route.title) {
        title = route.title;
      }

      if (!route.firstChild) break;
      route = route.firstChild;
    }

    return title;
  }
}
